import {
  BaseUniDriver,
  baseUniDriverFactory,
  UniDriver,
} from '@wix/wix-ui-test-utils/unidriver';
import { FieldsetDataHooks } from './types';

export interface FiedsetDriver extends BaseUniDriver {
  hasError(): Promise<boolean>;
  getErrorMessage(): Promise<string>;
  getLabel(): UniDriver;
  getLabelAsterisk(): UniDriver;
}

export const fieldsetDriverFactory = (base: UniDriver): FiedsetDriver => {
  return {
    ...baseUniDriverFactory(base),

    hasError: async () =>
      base.$(`[data-hook="${FieldsetDataHooks.Error}"]`).exists(),
    getErrorMessage: async () =>
      base.$(`[data-hook="${FieldsetDataHooks.Error}"]`).text(),
    getLabel: () => base.$(`[data-hook="${FieldsetDataHooks.Label}"]`),
    getLabelAsterisk: () =>
      base.$(`[data-hook="${FieldsetDataHooks.LabelAsterisk}"]`),
  };
};
